import { BRAND_SECONDARY } from "../../../utils/Styles";
import {
  Breadcrumb,
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DocumentCard,
  DocumentCardDetails,
  DocumentCardImage,
  DocumentCardTitle,
  DirectionalHint,
  Dropdown,
  DropdownMenuItemType,
  FocusTrapZone,
  IDropdownOption,
  ImageFit,
  ISelectableOption,
  PrimaryButton,
  Stack,
} from "office-ui-fabric-react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteCCTVImage,
  getAllCustomers,
  getCCTVImages,
} from "../../../services/customers/CustomerService";
import {
  ICCTVImage,
  ICustomers,
  IDataCenter,
  IFloorVM,
  ISearchCCTVImage,
} from "../../../vm";
import {
  API_URL,
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import moment from "moment";
import { getAllDataCentersOfCustomer } from "../../../services/datacenter/DatacenterService";
import ManageCCTVImage from "./ManageCCTVImage";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import NoDataTile from "../../common/NoDataTile";
import { mdiDotsVertical } from "@mdi/js";
import Icon from "@mdi/react";
import { getToken, parseJwt } from "../../../services/UtilService";
import { Loading } from "../../../services/Loading";

export interface CCTVImageMainProps { }

let calendarButtonElement: HTMLElement;

// const DayPickerStrings = {
//   months: [
//     'January',
//     'February',
//     'March',
//     'April',
//     'May',
//     'June',
//     'July',
//     'August',
//     'September',
//     'October',
//     'November',
//     'December',
//   ],
//   shortMonths: [
//     'Jan',
//     'Feb',
//     'Mar',
//     'Apr',
//     'May',
//     'Jun',
//     'Jul',
//     'Aug',
//     'Sep',
//     'Oct',
//     'Nov',
//     'Dec',
//   ],
//   days: [
//     'Sunday',
//     'Monday',
//     'Tuesday',
//     'Wednesday',
//     'Thursday',
//     'Friday',
//     'Saturday',
//   ],
//   shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
//   goToToday: 'Go to today',
//   weekNumberFormatString: 'Week number {0}',
//   prevMonthAriaLabel: 'Previous month',
//   nextMonthAriaLabel: 'Next month',
//   prevYearAriaLabel: 'Previous year',
//   nextYearAriaLabel: 'Next year',
//   prevYearRangeAriaLabel: 'Previous year range',
//   nextYearRangeAriaLabel: 'Next year range',
//   closeButtonAriaLabel: 'Close',
//   monthPickerHeaderAriaLabel: '{0}, select to change the year',
//   yearPickerHeaderAriaLabel: '{0}, select to change the month',
// };

const CCTVImageMain: React.FC<CCTVImageMainProps> = () => {
  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const tokenData = parseJwt();

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    customer: {
      name: "",
      regSapNo: "",
    },
    date: new Date(),
    showCallender: false,
    searchObj: {
      customerId: params.customerId,
      startDate: new Date(),
      endDate: new Date(),
      datacenterId: "all",
      floorId: "all",
    },
    dataCenters: [],
    dataCenterOptions: [],
    allFloorsDropdownList: [{ key: "all", text: "All" }],
    // cctvImages: [
    //   {
    //     imageUrl:
    //       "https://image.shutterstock.com/image-photo/bright-spring-view-cameo-island-260nw-1048185397.jpg",
    //     datacenterId: "",
    //     customerId: "",
    //     date: new Date(),
    //     image: "",
    //     floorId: "",
    //     description: "testt",
    //   },
    // ],
    cctvImages: [],
    manageCctvImage: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    customer: ICustomers;
    date: Date;
    showCallender: boolean;
    searchObj: ISearchCCTVImage;
    dataCenters: IDataCenter[];
    dataCenterOptions: IDropdownOption[];
    allFloorsDropdownList: IDropdownOption[];
    cctvImages: ICCTVImage[];
    manageCctvImage: {
      isOpen: boolean;
      index?: number;
      data?: ICCTVImage;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: ICCTVImage;
    };
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
      });
      searchDataCenters(result.data[0]);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer details",
        "error"
      );
    }
  };

  const searchDataCenters = async (customer?: ICustomers) => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCentersOfCustomer(params.customerId);
    if (result && result.success) {
      let options: IDropdownOption[] = [{ key: "all", text: "All" }];
      result.data.forEach((ele) => {
        options.push({ key: ele._id as string, text: ele.name });
      });
      let obj = {
        ...state,
        dataCenterOptions: options,
        dataCenters: result.data,
        customer,
      };
      getCctvImages(obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenters", "error");
    }
  };

  const getCctvImages = async (obj?: any, searchObj?: ISearchCCTVImage) => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.searchObj };
    if (searchObj) {
      tempSearch = { ...tempSearch, ...searchObj };
    }

    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    // .toDate();
    tempSearch.endDate = moment(tempSearch.endDate)
      .endOf("month")
      .format("YYYY-MM-DD");
    // .toDate();

    if (tempSearch.datacenterId === "all") {
      delete tempSearch.datacenterId;
    }
    if (tempSearch.floorId === "all") {
      delete tempSearch.floorId;
    }

    let result = await getCCTVImages(tempSearch);
    if (result?.success) {
      // console.log("result", result.data);
      setState({ ...state, ...obj, cctvImages: result.data });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting Temperature & Humidity",
        "error"
      );
    }
  };

  const onSearch = () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }
    getCctvImages();
  };
  const addImage = () => { };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>
          {option.data
            ? option.data.buildingName + "-" + option.text
            : option.text}
        </span>
      </div>
    );
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let cctvImage = undefined;
    if (index !== undefined) {
      cctvImage = { ...state.cctvImages[index] };
    }
    setState({
      ...state,
      manageCctvImage: {
        isOpen: isOpen,
        index: index,
        data: cctvImage,
      },
    });
  };

  const handleDialogClose = (data?: ICCTVImage) => {
    let cctvImages = [...state.cctvImages];
    if (data) {
      if (state.manageCctvImage.index !== undefined) {
        cctvImages[state.manageCctvImage.index] = data;
        showToast("CCTV Image updated successfully", "success");
      } else {
        cctvImages.unshift(data);
        showToast("CCTV Image added successfully", "success");
      }
    }
    setState({
      ...state,
      manageCctvImage: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      cctvImages,
    });
  };

  const deleteCctvImage = async (item: ICCTVImage, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete CCTV Image",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteCCTVImage(item._id as string);
        if (result?.success) {
          showToast(" CCTV Image deleted successfully", "success");
          let cctvImages = [...state.cctvImages];
          cctvImages.splice(index, 1);
          setState({
            ...state,
            cctvImages,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting CCTV Image",
            "error"
          );
        }
      }
    );
  };

  const handleLoading = () => {
    setState((prev) => ({
      ...prev,
      isLoading: !prev.isLoading,
    }));
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const getDatacenterAndFloor = (datacenterId: string, floorId: string) => {
    let datacenter = state.dataCenters.find((ele) => ele._id === datacenterId);
    let floor: any = {};
    let building: any = {};
    if (datacenter) {
      floor = datacenter.floors?.find((ele) => ele._id === floorId);
      building = datacenter.buildings?.find(
        (ele) => ele._id === floor?.buildingId
      );
      return `${datacenter?.name || ""} ${building?.name || ""}-${floor?.name || ""
        }`;
    } else {
      return "";
    }
  };

  const downloadCCTVImageReportPdf = async () => {
    let result = await fetch(
      `${API_URL}cctv-images-report?customerId=${state.searchObj.customerId
      }&startDate=${moment(state.searchObj.startDate)
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
          .endOf("month")
          .format("YYYY-MM-DD")}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${state.customer.name} Monthly CCTV Image Report.pdf`;
    a.click();
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: ICCTVImage
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${state.customer._id}`);
                },
              },
              {
                text: "CCTV Image",
                key: "cctv-image",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                <Stack.Item>
                  {/* <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    value={state.date}
                    showGoToToday={false}
                    showMonthPickerAsOverlay={true}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        date: date as any,
                        searchObj: {
                          ...state.searchObj,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).endOf("month").toDate(),
                        },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                  /> */}
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !state.date
                          ? "Select a month"
                          : moment(state.date).format("MMM-YYYY")
                      }
                      onClick={() =>
                        setState({ ...state, showCallender: true })
                      }
                      className="month-picker-btn"
                    />
                  </div>
                  {state.showCallender && (
                    <Callout
                      isBeakVisible={false}
                      className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) =>
                            setState({
                              ...state,
                              date: date as any,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).endOf("month").toDate(),
                              },
                              showCallender: false,
                            })
                          }
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={state.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.dataCenterOptions}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        let datacenter = state.dataCenters.find(
                          (ele) => ele._id === v.key
                        );
                        let options: IDropdownOption[] = [
                          { key: "all", text: "All" },
                        ];
                        if (datacenter) {
                          const floorByBuilding: {
                            [Key: string]: IFloorVM[];
                          } = datacenter.floors.reduce((acc: any, d) => {
                            if (acc[d.buildingId] == null) {
                              acc[d.buildingId] = [];
                            }
                            let buildingName =
                              datacenter?.buildings.find(
                                (ele) => ele._id === d.buildingId
                              )?.name || "";
                            acc[d.buildingId].push({
                              buildingId: d.buildingId,
                              buildingName,
                              floorId: d._id,
                              floorName: d.name,
                            });
                            return acc;
                          }, {});
                          let temp = Object.keys(floorByBuilding);
                          temp.forEach((d, index) => {
                            options.push({
                              key: d,
                              text: floorByBuilding[d][0].buildingName,
                              itemType: DropdownMenuItemType.Header,
                            });
                            floorByBuilding[d].forEach((f) => {
                              options.push({
                                key: f.floorId,
                                text: f.floorName,
                                data: { buildingName: f.buildingName },
                              });
                            });
                            if (temp.length != index + 1) {
                              options.push({
                                key: "divider_1",
                                text: "-",
                                itemType: DropdownMenuItemType.Divider,
                              });
                            }
                          });

                          // console.log("[options]", options);
                        }
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                            floorId: "all",
                          },
                          allFloorsDropdownList: options,
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    selectedKey={state.searchObj.floorId}
                    // defaultSelectedKey={state.searchObj.floorId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                            // upsId: '',
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <Stack horizontal tokens={childrenGap}>
                <Stack.Item>
                  <DefaultButton
                    text='Download Report'
                    onClick={() => downloadCCTVImageReportPdf()}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton
                    text='Add CCTV Image'
                    onClick={() => handleDialogOpen(true)}
                  />
                </Stack.Item>
              </Stack>
            </Stack.Item> */}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            horizontalAlign="space-between"
            wrap
            tokens={childrenGap}
          >
            <Stack.Item>
              <PrimaryButton
                text="Download Report"
                onClick={() => downloadCCTVImageReportPdf()}
                disabled={
                  state.isLoading === true || state.cctvImages.length === 0
                }
              />
            </Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <Stack.Item>
                <PrimaryButton
                  text="Add CCTV Image"
                  onClick={() => handleDialogOpen(true)}
                  className="borderless-btn bg-white"
                />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        <br />
        <Stack.Item>
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              {state.cctvImages.length > 0 ? (
                state.cctvImages.map((item, index) => (
                  <div
                    key={index}
                    className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 ms-xxl2 img-card-alignment"
                  >
                    <DocumentCard
                      style={{ maxWidth: "100%" }}
                      className="w-100"
                    >
                      <DocumentCardImage
                        height={115}
                        imageFit={ImageFit.cover}
                        imageSrc={item.imageUrl}
                      />
                      <DocumentCardDetails
                        styles={{
                          root: {
                            height: 60,
                            backgroundColor: "#f4f4f4",
                          },
                        }}
                      >
                        <DocumentCardTitle
                          styles={{
                            root: {
                              color: BRAND_SECONDARY,
                              fontSize: 14,
                            },
                          }}
                          className="letter-spacing"
                          title={
                            (
                              <React.Fragment>
                                <Stack
                                  horizontal
                                  horizontalAlign="space-between"
                                >
                                  <Stack.Item>
                                    {getDatacenterAndFloor(
                                      item.datacenterId,
                                      item.floorId
                                    )}
                                  </Stack.Item>
                                  {![2, 4, 5].includes(tokenData.role) && (
                                    <Stack.Item>
                                      <span
                                        onClick={(ele) =>
                                          handleCallOutOpenClose(
                                            true,
                                            ele,
                                            index,
                                            item
                                          )
                                        }
                                      >
                                        <Icon
                                          path={mdiDotsVertical}
                                          size={0.9}
                                          className="pointer"
                                          color={BRAND_SECONDARY}
                                        />
                                      </span>
                                      {/* <Stack
                                      horizontal
                                      wrap
                                      tokens={childrenGap8}
                                    >
                                      <Stack.Item>
                                        <TooltipHost
                                          content={"Edit"}
                                          id={`editCCTVImage`}
                                          calloutProps={{
                                            gapSpace: 0,
                                          }}
                                          styles={{
                                            root: {
                                              display: "inline-block",
                                            },
                                          }}
                                        >
                                          <span
                                            onClick={() =>
                                              handleDialogOpen(true, index)
                                            }
                                          >
                                            <Icon
                                              path={mdiPencilOutline}
                                              size={0.8}
                                              className="pointer"
                                              color={
                                                THEME.palette.neutralPrimary
                                              }
                                            />
                                          </span>
                                        </TooltipHost>
                                      </Stack.Item>
                                      <Stack.Item>
                                        <TooltipHost
                                          content={"Remove"}
                                          id={`removeCCTVImage`}
                                          calloutProps={{
                                            gapSpace: 0,
                                          }}
                                          styles={{
                                            root: {
                                              display: "inline-block",
                                            },
                                          }}
                                        >
                                          <span
                                            onClick={() =>
                                              deleteCctvImage(item, index)
                                            }
                                          >
                                            <Icon
                                              path={mdiTrashCanOutline}
                                              size={0.8}
                                              className="pointer"
                                              color={THEME.palette.themePrimary}
                                            />
                                          </span>
                                        </TooltipHost>
                                      </Stack.Item>
                                    </Stack> */}
                                    </Stack.Item>
                                  )}
                                </Stack>
                              </React.Fragment>
                            ) as any
                          }
                        />
                        <DocumentCardTitle
                          styles={{
                            root: {
                              color: BRAND_SECONDARY,
                              fontSize: 12,
                            },
                          }}
                          title={item?.description + " of the month" || ""}
                          showAsSecondaryTitle
                        />
                      </DocumentCardDetails>
                    </DocumentCard>
                  </div>
                ))
              ) : (
                <React.Fragment>
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">
                    <Stack horizontal horizontalAlign="center">
                      <Stack.Item>
                        <NoDataTile title="No CCTV Images"></NoDataTile>
                      </Stack.Item>
                    </Stack>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 170, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteCctvImage(
                    state.manageActionsCallout.data as ICCTVImage,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageCctvImage.isOpen && (
        <ManageCCTVImage
          data={state.manageCctvImage.data}
          handleLoading={handleLoading}
          customerId={params.customerId}
          handleDialogClose={(data?: ICCTVImage) => handleDialogClose(data)}
          dataCenters={state.dataCenters}
          dataCenterOptions={state.dataCenterOptions}
          date={state.date}
        />
      )}
    </React.Fragment>
  );
};

export default CCTVImageMain;
